
const isStatusCode = (error, code) => {
    try {
        return error.response.status === code;
    } catch (error) {
        // console.log('isStatusCode()', error)
    }
};

const getErrorMessage = (error) => {
    if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
    } else if (error && error.message) {
        return error.message;
    }
};

const getErrorCode = (error) => {
    if (error && error.response && error.response.data && error.response.data.code) {
        return error.response.data.code;
    }
};


module.exports = {
    isStatusCode,
    getErrorMessage,
    getErrorCode,
};